import './App.css';
import {Routes, Route, BrowserRouter} from "react-router-dom"
import Login from './pages/Login';
import Home from './pages/Home';
import InfoVisa from './pages/InfoVisa';
import InfoSaving from './pages/InfoSaving';
import DashBoardSaving from './pages/DashBoardSaving';
import DashBoardVisa from './pages/DashBoardVisa';
import Error from './Components/Error';
import {TokenProvider} from './context/TokenContext'
import InfoApple from "./pages/InfoApple";
import DashBoardApple from "./pages/DashBoardApple";
import InfoMerchant from "./pages/InfoMerchant";
import DashBoardMerchant from "./pages/DashBoardMerchant";
import InfoHappyPay from "./pages/InfoHappyPay";
import DashBoardHappyPay from "./pages/DashBoardHappyPay";
import HappyPayLottery from "./pages/lottery/HappyPayLottery";
import ProtectedRoute from "./Components/ProtectedRoute";
import LotteryTokenProvider from "./Components/lottery/LotteryTokenProvider";
import AdminLotteryPanel from "./pages/lottery/AdminLotteryPanel";
import LotteryLogin from "./pages/lottery/LotteryLogin";


function App() {
    return (
        <div className="App w-full">
            <TokenProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/login/:id/:reg" element={<Login/>}/>
                        <Route path="/infosaving" element={<InfoSaving/>}/>
                        <Route path="/infovisa" element={<InfoVisa/>}/>
                        <Route path="/infomerchant" element={<InfoMerchant/>}/>
                        <Route path="/infoapple" element={<InfoApple/>}/>
                        <Route path="/infohappy" element={<InfoHappyPay/>}/>
                        <Route path="/dashboardmerchant" element={<DashBoardMerchant/>}/>
                        <Route path="/dashboardsaving" element={<DashBoardSaving/>}/>
                        <Route path="/dashboardvisa" element={<DashBoardVisa/>}/>
                        <Route path="/dashboardapple" element={<DashBoardApple/>}/>
                        <Route path="/dashboardhappy" element={<DashBoardHappyPay/>}/>
                        <Route path="/happypaylottery/*" element={<LotteryRoutes/>}/>
                        <Route path="/soon" element={<Error type="soon"/>}/>
                        <Route path="*" element={<Error type="404"/>}/>
                    </Routes>
                </BrowserRouter>
            </TokenProvider>
        </div>
    );
}

const LotteryRoutes = () => (
    <LotteryTokenProvider>
        <Routes>
            <Route path="/" element={
                <ProtectedRoute>
                    <HappyPayLottery/>
                </ProtectedRoute>
            }/>
            <Route path="/admin" element={
                <ProtectedRoute requireAdmin={true}>
                    <AdminLotteryPanel />
                </ProtectedRoute>
            } />
            <Route path="/login" element={<LotteryLogin/>}/>
            <Route path="/unauthorized" element={<Error type="unauthorized"/>}/>
        </Routes>
    </LotteryTokenProvider>
);


export default App;
